import React from 'react'
import { Chip, ChipProps } from '@mui/material'

export type LabelProps = ChipProps & {
  name: string
}

export const Label = ({ name, ...params }: LabelProps) => {
  return (
    <Chip {...params} label={name} variant="outlined" />
  )
}
